import Nav from 'react-bootstrap/Nav';
import constants from "../../helpers/constants";
import { useLocation } from "react-router-dom"
import React, { Component }  from 'react';
function StackedExample(prop) {
  const location = useLocation()
  console.log(location);
  let menutItems = [];
  if (location.pathname.includes('Flight'))
    menutItems.push(...constants.MENU_ITEMS_FLIGHT);
 else if (location.pathname.includes('Hotel'))
    menutItems.push(...constants.MENU_ITEMS_HOTEL);
    else if (location.pathname.includes('Train'))
    menutItems.push(...constants.MENU_ITEMS_TRAIN);
    else if (location.pathname.includes('Bus'))
    menutItems.push(...constants.MENU_ITEMS_BUS);
    else
    menutItems.push(...constants.MENU_ITEMS_FLIGHT);


  const MenuItem = (x) => {
    return (
      <Nav.Link className='Sidebar-link' href={x.link}
      >
        {x.title}
      </Nav.Link>
    )
  };

  return (
    <Nav className="flex-column">
      {menutItems.map(x => MenuItem(x))}
    </Nav>
  );
}

export default StackedExample;